module.exports = __webpack_public_path__ + "img/inbox.8c292cbc.svg";